import Big from 'big.js';
import type { Dispatch, SetStateAction } from 'react';
import { Period } from 'types';

export const facets = ['BLOCK', 'ROW', 'OUTLET_OR_SERVICE_CATEGORY', 'ACTIVITY'] as const;

export type Facet = (typeof facets)[number];

export const feeModes = ['INCLUDED', 'EXPANDED', 'GROUPED'] as const;

export type FeeMode = (typeof feeModes)[number];

export type Template = {
  facet: Facet;
  // canSetFeeMode
  feeMode: FeeMode;
  // canAppendComment
  appendComment: boolean;
  // canTransparentUnits
  altActivityName: boolean;
  // canTransparentUnits
  transparentUnits: boolean;
  // canAppendPONumbers
  appendPONumbers: boolean;
};

export type Selection = Record<string, string[]>;

export type BuilderState = {
  selection: Selection;
  template: Template;
  select: (blockId: string, month: string) => void;
  setTemplate: Dispatch<SetStateAction<Template>>;
  clear?: () => void;
};

export type AmountFields = {
  target: Big;
  invoiced: Big;
  invoiceable: Big;
};

export type MonthAmount = {
  invoiceable: Big;
  target: Big;
  quantity: string | null;
};

export type BuilderMonth = AmountFields & {
  amounts: Record<string, MonthAmount>;
};

export type BuilderBlock = AmountFields & {
  id: string;
  // sums: BlockSums;
  months: Record<string, BuilderMonth>;
};

export type BuilderContext = {
  period: Period | null;
  blocks: BuilderBlock[];
};
